// nodeEnv.js

var _isTest = function isTest() {
  return process.env.NODE_ENV === 'test';
};
var _isDev = function isDev() {
  return !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
};
var _isProduction = function isProduction() {
  return process.env.NODE_ENV === 'production';
};
var nodeEnv = {
  isDev: function isDev() {
    return _isDev();
  },
  isProduction: function isProduction() {
    return _isProduction();
  },
  isTest: function isTest() {
    return _isTest();
  }
};

export { nodeEnv as default, _isDev as isDev, _isProduction as isProduction, _isTest as isTest };
